/**
 * @generated SignedSource<<c8931a31b3a9bb676a7fb5132f6a59bd>>
 * @relayHash e713db4fcdaafe3028924eea8afe40c6
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID af105836af8fe40aae915bb8d854312bf9b0c4558be466a78bc5b9968ca1af87

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SchemaProposalStatus = "APPROVED" | "DRAFT" | "IMPLEMENTED" | "IN_REVIEW" | "REJECTED";
export type proposalPageLayoutQuery$variables = {
  accountSlug: string;
  branchName: string;
  graphSlug: string;
  proposalId: string;
};
export type proposalPageLayoutQuery$data = {
  readonly branch: {
    readonly id: string;
  };
  readonly schemaProposal: {
    readonly author: {
      readonly id: string;
    } | null | undefined;
    readonly description: string | null | undefined;
    readonly id: string;
    readonly status: SchemaProposalStatus;
    readonly title: string;
    readonly " $fragmentSpreads": FragmentRefs<"infoProposalFragment">;
  };
  readonly viewer: {
    readonly id: string;
  };
};
export type proposalPageLayoutQuery = {
  response: proposalPageLayoutQuery$data;
  variables: proposalPageLayoutQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountSlug"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "branchName"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "graphSlug"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "proposalId"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  (v4/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "viewer",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v7 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "proposalId"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "accountSlug",
      "variableName": "accountSlug"
    },
    {
      "kind": "Variable",
      "name": "graphSlug",
      "variableName": "graphSlug"
    },
    {
      "kind": "Variable",
      "name": "name",
      "variableName": "branchName"
    }
  ],
  "concreteType": "Branch",
  "kind": "LinkedField",
  "name": "branch",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "proposalPageLayoutQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": (v6/*: any*/),
        "action": "THROW"
      },
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v7/*: any*/),
          "concreteType": "SchemaProposal",
          "kind": "LinkedField",
          "name": "schemaProposal",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            (v8/*: any*/),
            (v9/*: any*/),
            (v10/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "author",
              "plural": false,
              "selections": (v5/*: any*/),
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "infoProposalFragment"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      },
      {
        "kind": "RequiredField",
        "field": (v11/*: any*/),
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "proposalPageLayoutQuery",
    "selections": [
      (v6/*: any*/),
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": "SchemaProposal",
        "kind": "LinkedField",
        "name": "schemaProposal",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "author",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "avatarUrl",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v11/*: any*/)
    ]
  },
  "params": {
    "cacheID": "e713db4fcdaafe3028924eea8afe40c6",
    "id": "af105836af8fe40aae915bb8d854312bf9b0c4558be466a78bc5b9968ca1af87",
    "metadata": {},
    "name": "proposalPageLayoutQuery",
    "operationKind": "query",
    "text": "query proposalPageLayoutQuery(\n  $accountSlug: String!\n  $graphSlug: String!\n  $branchName: String!\n  $proposalId: ID!\n) {\n  viewer {\n    id\n  }\n  schemaProposal(id: $proposalId) {\n    id\n    title\n    description\n    status\n    author {\n      id\n    }\n    ...infoProposalFragment\n  }\n  branch(accountSlug: $accountSlug, graphSlug: $graphSlug, name: $branchName) {\n    id\n  }\n}\n\nfragment infoProposalFragment on SchemaProposal {\n  id\n  author {\n    name\n    avatarUrl\n    id\n  }\n  createdAt\n  status\n}\n"
  }
};
})();

(node as any).hash = "67c099521d1e7dfc93308f5451a77463";

export default node;
